
const stripe_api_key=from_webpack.stripe_api_key;

var stripe_instance=null;
var stripe_card_instance=null;

module.exports.init_stripe = async (loadStripe)=>{
    // Stripeライブラリのロード
    stripe_instance = await loadStripe(stripe_api_key);
}

module.exports.get_stripe_instance = ()=> stripe_instance;
module.exports.get_stripe_card_instance = ()=> stripe_card_instance;

module.exports.mount_stripe_card = (selector_mount_point='#card-element') => {
    const elements = stripe_instance.elements();

    var elementStyles = {
        base: {
            color: '#424770',
            fontWeight: 600,
            fontFamily: 'Quicksand, Open Sans, Segoe UI, sans-serif',
            fontSize: '16px',
            fontSmoothing: 'antialiased',

            ':focus': {
            color: '#424770',
            },

            '::placeholder': {
            color: '#9BACC8',
            },

            ':focus::placeholder': {
            color: '#CFD7DF',
            },
        },
        invalid: {
            color: '#fff',
            ':focus': {
            color: '#FA755A',
            },
            '::placeholder': {
            color: '#FFCCA5',
            },
        },
        };

        var elementClasses = {
            focus: 'focus',
            empty: 'empty',
            invalid: 'invalid',
        };
    

    // カード番号
    const cardNumber = elements.create('cardNumber', {
        style: elementStyles,
        classes: elementClasses
    });
    cardNumber.mount('#card-number');
    // 代表でカード番号のインスタンスを使える
    stripe_card_instance = cardNumber;
    
    // カードの有効期限
    const cardExpiry = elements.create('cardExpiry', {
        style: elementStyles,
        classes: elementClasses
    });
    cardExpiry.mount('#card-expiry');
    
    // カードのCVC入力
    const cardCvc = elements.create('cardCvc', {
        style: elementStyles,
        classes: elementClasses,
    });
    cardCvc.mount('#card-cvc');    

    //// card Element のインスタンスを作成
    //stripe_card_instance = elements.create('card', {
    //    style: style,
    //    hidePostalCode:true,
    //    classes: {
    //        base:"form-control credit_account",
    //    }
    //});


    // マウント
    //stripe_card_instance.mount(selector_mount_point);

}
